export default __webpack_public_path__ + "static/media/icon-redeem.37eba09f.svg";